var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.518 17.3416C10.2346 17.4416 9.76797 17.4416 9.48464 17.3416C7.06797 16.5166 1.66797 13.075 1.66797 7.24165C1.66797 4.66665 3.74297 2.58331 6.3013 2.58331C7.81797 2.58331 9.15964 3.31665 10.0013 4.44998C10.843 3.31665 12.193 2.58331 13.7013 2.58331C16.2596 2.58331 18.3346 4.66665 18.3346 7.24165C18.3346 13.075 12.9346 16.5166 10.518 17.3416Z",
    stroke: "#E5EAF9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedSupport);
export default __webpack_public_path__ + "static/media/needSupport.0dd71cb452d0542c4421c83629340079.svg";
export { ForwardRef as ReactComponent };